import classNames from 'classnames';
import React from 'react';
import styles from "../list-menu.module.css";
export const DesktopNavSectionHeading = ({
  children,
  props
}) => {
  return /*#__PURE__*/React.createElement("h2", Object.assign({
    className: classNames('ud-heading-sm', styles.heading)
  }, props), children);
};
//# sourceMappingURL=desktop-nav.react-component.js.map